/**
 * Centralized Pixi.js extensions registration
 * This file should be imported before any component that uses Pixi elements
 * to ensure extend() is only called once per element type
 */
import { extend } from "@pixi/react";
import {
  Container,
  Text,
  BitmapText,
  HTMLText,
  Graphics,
  Sprite,
} from "pixi.js";

// Extend all Pixi elements used in the library
extend({ Container, Text, BitmapText, HTMLText, Graphics, Sprite });

// Export extended types for JSX usage
export type { Container, Text, BitmapText, HTMLText, Graphics, Sprite };
